import React, { useEffect, useState } from 'react'
import "bootstrap/dist/css/bootstrap.min.css";
import ApplicationForm from './AppplicationForm/ApplicationForm';
import CandidateProfile from './AppplicationForm/CandidateProfile';
import { useSelector } from 'react-redux';
import BasicPreview from './BasicPreview';
// import { useLocation } from 'react-router-dom';
// import { useLocation } from 'react-router-dom';

const ProfileDetailsWay = () => {

  const tabdetails = useSelector((state) => state.reducers.loginreducer.tabdetails);
  const [latestTab, setlatestTab] = useState(tabdetails?.latestTab)
  const [currentStep, setCurrentStep] = useState(latestTab);

  const totalSteps = 4;

  const handleToProfile = () => {
    setCurrentStep(1)
  }

  const showStep = (step) => {
    //console.log("setps.'", step, "latestTab", latestTab, "tabdetails", tabdetails, "parseInt(step) <= latestTab ", parseInt(step) <= latestTab, "final status", parseInt(step) <= latestTab || (latestTab === 3))
    if ((parseInt(step) <= latestTab || (latestTab === 3 && step === 3)) && tabdetails?.confirm === false) {
      // alert("hiiii")
      setCurrentStep(parseInt(step))
    }
  };
  const handleNext = () => {
    if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
      setlatestTab(currentStep + 1)
    }

  };
  const renderTabContent = (val) => {
    switch (val) {
      case 1:
        return <CandidateProfile handleNext={handleNext} />;
      case 2:
        return <ApplicationForm handleNext={handleNext} />;
      case 3:
        return <BasicPreview handleNext={handleNext} handleToProfile={handleToProfile} />;
      default:
        return <BasicPreview handleNext={handleNext} handleToProfile={handleToProfile} />;
    }
  };
  useEffect(() => {
    setCurrentStep(latestTab);
  }, [latestTab]);

  return (
    <div className="">
      <div className="stepper">
        <div className="stepper-header d-lg-flex d-block justify-content-between mb-4">
          <div className={`step ${currentStep === 1 && tabdetails?.confirm === false ? "active" : tabdetails?.latestTab > 1 ? 'completed' : ''}`}
            onClick={() => showStep(1)} onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                showStep(1)
              }
            }}>Profile</div>
          <div className={`step ${currentStep === 2 && tabdetails?.confirm === false ? "active" : tabdetails?.latestTab > 2 || tabdetails?.confirm === true ? 'completed' : ''}`}
            onClick={() => { showStep(2); }} onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                showStep(2)
              }
            }}>Academic Qualifications</div> <div
              className={`step ${currentStep === 3 ? "active" : currentStep >= 3 ? 'completed' : ''}`}
              onClick={() => showStep(3)} onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  showStep(3)
                }
              }}> Preview </div>
        </div>
        <div className="stepper-body p-0 pb-1" style={{ marginTop: '5%' }}>
          <div className="stepper-content active">
            {currentStep === 1 ? renderTabContent(1) :
              currentStep === 2 ? renderTabContent(2) :
                currentStep === 3 ? renderTabContent(3) : ''}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileDetailsWay;
